<template>
    <ContextMenu :model="model" ref="cm" :global="true" />
</template>

<script setup lang="ts">
import type { MenuItem } from 'primevue/menuitem';
import ContextMenu from 'primevue/contextmenu'

import { ref } from 'vue';

defineProps<{
    model?: MenuItem[];
}>();

const cm = ref();

const show = (event: Event) => {
    if (event) {
        event.preventDefault();
        cm.value?.show(event);
    }
};

const hide = () => {
    cm.value?.hide();
};

defineExpose({
    show,
    hide
});
</script>
